<template>
    <div>
        <div class="row mt-3 pl-0 pl-md-5 pl-lg-0">
            <div class="col-12 col-lg-5 d-flex flex-lg-column flex-row align-items-center">
                <b>Engate:</b>
                <div class="pl-2 pl-lg-0">
                    {{ connectorTypeSelected.name }}
                </div>
            </div>
            <div class="col-12 col-lg-3 d-flex flex-lg-column flex-row align-items-center">
                <b>Operação:</b>
                <div class="pl-2 pl-lg-0">
                    {{ culturePracticeSelected.text }}
                </div>
            </div>
            <div class="col-12 col-lg-4 d-flex flex-lg-column flex-row align-items-center">
                <b>Ponto de trabalho:</b>
                <div class="pl-2 pl-lg-0">
                    {{ measurements.function[0].erp[0] }} cm
                </div>
            </div>
        </div>
        <div class="row mt-4 mb-2">
            <div class="col-12 col-lg-6 d-flex flex-column align-items-center">
                <b>Centro de rotação</b>
                <img class="image" src="@/assets/images/implement/implement-crp_x.png">
                {{ measurements.crp[0] + ' cm - ' + measurements.implement_position.name }}
            </div>
            <div class="col-12 col-lg-6 d-flex flex-column align-items-center mt-3 mt-lg-0">
                <b>Largura de trabalho</b>
                <img class="image" src="@/assets/images/implement/implement-width.png">
                {{ measurements.function[0].width + ' cm - ' +
            parseNumberOfSections(measurements.function[0].number_of_sections) }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        parseNumberOfSections(numberOfSections) {
            if (!numberOfSections) {
                numberOfSections = 1
            }
            if (numberOfSections === 1) {
                return this.$t('AppImplementMeasurementsImplementView.1 seção')
            }
            return numberOfSections + this.$t('AppImplementMeasurementsImplementView.seções')
        }
    },
    props: {
        connectorTypeSelected: {
            type: Object,
            required: true
        },
        culturePracticeSelected: {
            type: Object,
            required: true
        },
        measurements: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss">
.image {
    max-width: 15vw;
}
@media (max-width: 758px) {
    .image {
        max-width: 60vw;
    }
}
@media (max-width: 1024px) and (min-width: 758px) {
    .image {
        max-width: 25vw;
    }
}
</style>
